import { render } from "./t.vue?vue&type=template&id=4666a289&scoped=true&ts=true&lang=pug"
import script from "./t.vue?vue&type=script&lang=ts"
export * from "./t.vue?vue&type=script&lang=ts"

import "./t.vue?vue&type=style&index=0&id=4666a289&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4666a289"]])

export default __exports__